import VariantSchema from './Variant.schema';
import { ErrorType } from '../../types/error.type';

export type GetVariantListResponseDto = {
  getVariantList: {
    results: VariantSchema[],
    errors: ErrorType[]
  }
}

export const GET_VARIANT_LIST = (entityId: string): string => `query GetVariantList {
  getVariantList(getVariantListInput: {entityId: "${entityId}"}) {
    ... on GetVariantsOutput {
      results {
        details
        entityId
        feature
        featureName
        project
        reason
        variation
        value {
          stringValue
          longValue
          boolValue
          doubleValue
        }
      }
    }
    ... on ErrorListOutput {
      errors {
        id
        message
        type
      }
    }
  }
}`;
